module.exports = __webpack_public_path__ + "img/on-time.02049d53.webp";